import { API_CALL_ERROR } from './../../../../store/action';
import { SCAN_RACK_COMP } from './../edit/edit.const';
import { ApiService } from './../../../../api/api.service';
import { PreloaderService } from './../../../../common/services/preloader/preloader.service';
import { AppInjector } from './../../../../app-injector';
import { FETCH_ALL_TRACK_REQUESTED, FETCH_ALL_TRACK_SUCCEEDED } from './track-history.actions';
import { takeEvery, put } from 'redux-saga/effects';
import * as _ from 'lodash';

function* fetchAllTrack(action) {
  try {
    AppInjector.get(PreloaderService).show();
    const result = yield AppInjector.get(ApiService)
      .track.get(_.assign({ constraints: JSON.stringify(action.data) }, { sort: '-id', with: 'location' }))
      .toPromise();

    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case SCAN_RACK_COMP:
          yield put({
            type: FETCH_ALL_TRACK_SUCCEEDED,
            data: result,
            com: SCAN_RACK_COMP
          });
          break;

        default:
          break;
      }
    } else {
    }
    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchAllTrackRequest() {
  yield takeEvery(FETCH_ALL_TRACK_REQUESTED, fetchAllTrack);
}

export default [watchFetchAllTrackRequest];
